import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { QuoteBand } from "@/components/QuoteBand";
import { Testimonials } from "@/components/Testimonials";
import { Services } from "@/components/Services";
import { Booking } from "@/components/Booking";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

function App() {
  return (
    <div className="App font-body">
      <Navbar />
      <main>
        <Hero />
        <About />
        <QuoteBand />
        <Testimonials />
        <Services />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
